import { useEditorContext } from "../EditorContext";
import { useEffect } from "react";
import { PASTE_COMMAND, COMMAND_PRIORITY_HIGH } from "lexical";

export default function PasteImagePlugin() {
	const {addAttachment,editor } = useEditorContext();

	useEffect(() => {
		return editor.registerCommand(
			PASTE_COMMAND,
			(event) => {
				const items = event.clipboardData?.items;
				if (!items) return false;

				for (const item of items) {
					if (item.type.startsWith("image/")) {
						addAttachment(item.getAsFile());
						return true;
					}
				}
				return false;
			},
			COMMAND_PRIORITY_HIGH
		);
	}, [editor, addAttachment]);

	return null;
}
